import React, { useState, useEffect, useMemo } from 'react';
import TeacherCard from '../components/common/TeacherCard';
import Footer from '../components/layout/Footer';
import { getAllTeachers } from '../services/api';

const Teachers = () => {
  window.scrollTo(0, 0);
  const [teachers, setTeachers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const response = await getAllTeachers();
        if (response && response.data) {
          const teachersWithMethods = response.data.map((teacher) => ({
            id: teacher.id,
            full_name: teacher.full_name,
            major: teacher.major,
            degree: teacher.degree,
            phone_number: teacher.phone_number,
            teaching_method: teacher.teaching_method
              ? teacher.teaching_method.split(',').map((m) => m.trim())
              : [],
            experience: teacher.experience || Math.floor(Math.random() * 11) + 1, // tạm random 1-10 năm
            school: teacher.workplace || "Chưa Có", // fallback
            image_url: teacher.image_url || null, // fallback
          }));

          setTeachers(teachersWithMethods);

          setTeachers(teachersWithMethods);
        }
      } catch (error) {
        console.error('Error fetching teachers:', error);
      }
    };
    fetchTeachers();
  }, []);

  // Filter by name or subject
  const filteredTeachers = useMemo(() => {
    return teachers.filter((teacher) =>
      (teacher.full_name && teacher.full_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (teacher.major && teacher.major.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  }, [searchTerm, teachers]);


  const totalPages = Math.ceil(filteredTeachers.length / itemsPerPage);
  const currentTeachers = filteredTeachers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  return (
    <div className="pt-16 min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-gradient-to-r from-primary-600 to-primary-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Đội Ngũ Giáo Viên</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Gặp gỡ đội ngũ giáo viên hàng đầu TOP 1% với kinh nghiệm và chuyên môn cao
          </p>
        </div>
      </section>

      {/* Search */}
      <div className="max-w-3xl mx-auto mt-10 px-4">
        <input
          type="text"
          placeholder="Tìm kiếm theo tên giáo viên hoặc môn học..."
          value={searchTerm}
          onChange={handleSearch}
          className="w-full p-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
        />
      </div>

      {/* Teachers Grid */}
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {currentTeachers.map((teacher) => (
              <TeacherCard key={teacher.id} teacher={teacher} />
            ))}
          </div>

          {/* Pagination Controls */}
          <div className="mt-10 flex justify-center space-x-2">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                onClick={() => setCurrentPage(i + 1)}
                className={`px-4 py-2 rounded-lg border ${currentPage === i + 1
                  ? 'bg-primary-600 text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-100'
                  }`}
              >
                {i + 1}
              </button>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Teachers;
